module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "my-container"
  }, [_c('el-header', {
    attrs: {
      "height": "50px"
    }
  }, [_c('VHeader')], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63998a0d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/container.vue
// module id = 1419
// module chunks = 1